import React, { Component, useState } from 'react';
import { makeStyles } from "@material-ui/core";
import { NavLink } from "react-router-dom";
import Popper from '@material-ui/core/Popper';
import Fade from '@material-ui/core/Fade';
import { useHistory } from 'react-router-dom';

export default function HeaderComponent(props) {

    const classes = useStyles();
    const [anchorEl, setAnchorEl] = useState(null)
    const [placement, setPlacement] = useState(null)

    const open = Boolean(anchorEl);
    const id = open ? 'simple-popper' : undefined;
    let username = props.authentication.username;
    let history = useHistory();

    const logOut = () => {
        props.actions.logout();
        history.push('/login');
    }

    const handleClick = (newPlacement) => (event) => {
        setAnchorEl(anchorEl?null:event.currentTarget)
        setPlacement(newPlacement)
    };

    return (
        <div className={classes.headerComponent}>
            <div className={classes.imgLogo}>
                <img className={classes.img} src={process.env.PUBLIC_URL + '/img/mydibelHeaderLogo.png'}></img>
            </div>
            <div className={classes.links}>
                <NavLink to="/" className={classes.createContractLink} activeClassName={classes.createContractActiveLink} exact={true}>
                   Create contract
                    </NavLink>
                <NavLink to="/overview" className={classes.contractOverviewLink} activeClassName={classes.contractOverviewActiveLink}>
                    Contract overview
                    </NavLink>
            </div>
            <div className={classes.user}>
                <div className={classes.imgLogOut}>
                    <button className={classes.logoutButton} aria-describedby={id} type="button" onClick={handleClick('bottom-end')}>
                        <img src={process.env.PUBLIC_URL + '/img/icon_down.png'}></img>
                    </button>
                    <Popper id={id} open={open} anchorEl={anchorEl} placement={placement} transition>
                        {({ TransitionProps }) => (
                            <Fade {...TransitionProps} timeout={500}>
                                <div className={classes.paper} onClick={() => logOut()}>Logout</div>
                            </Fade>
                        )}
                    </Popper>
                </div>
                <div className={classes.hiUser}>
                    Hi, {username}
                </div>
                <div className={classes.imgUser}>
                    <img src={process.env.PUBLIC_URL + '/img/user.png'}></img>
                </div>
            </div>

        </div>
    )
}


const useStyles = makeStyles({
    headerComponent: {
        height: "105px",
        width: "100%",
        backgroundColor: "white",
        boxShadow: "0px 3px 6px #00000029"
    },
    imgLogo: {
        float: "left"
    },
    img: {
        marginTop: "10px",
        marginLeft: "39px"
    },
    links: {
        float: "left",
        paddingTop: "40px",
        marginLeft: "70px",
        width: "auto"
    },
    createContractLink: {
        float: "left",
        fontFamily: "Roboto",
        fontSize: "20px",
        color: "#616A6E",
        textDecoration: "none"
    },
    contractOverviewLink: {
        float: "left",
        marginLeft: "45px",
        fontFamily: "Roboto",
        fontSize: "20px",
        color: "#616A6E",
        textDecoration: "none"
    },
    createContractActiveLink: {
        float: "left",
        fontFamily: "Roboto",
        fontSize: "20px",
        color: "#1583C3",
        fontWeight: "bold",
        textDecoration: "underline"
    },
    contractOverviewActiveLink: {
        float: "left",
        marginLeft: "45px",
        fontFamily: "Roboto",
        fontSize: "20px",
        color: "#1583C3",
        fontWeight: "bold",
        textDecoration: "underline"
    },
    imgUser: {
        float: "right"
    },
    imgLogOut: {
        float: "right",
        marginRight: "40px"
    },
    hiUser: {
        float: "right",
        fontFamily: "Roboto",
        fontSize: "18px",
        color: "#616A6E",
        fontWeight: "bolder",
        marginLeft: "8px",
        marginRight: "8px"
    },
    user: {
        paddingTop: "40px"
    },
    logoutButton: {
        backgroundColor: "white",
        border: "0px",
        outline: "none",
        cursor: "pointer"
    },
    paper: {
        border: "1px solid",
        fontFamily: "Roboto",
        fontSize: "16px",
        color: "#616A6E",
        padding: "20px",
        backgroundColor: "white",
        marginTop: "10px",
        cursor: "pointer"
    }
});

